import * as z from 'zod'

const stringOptional = () => z.string().optional().nullable()
const stringRequired = (message: string) => z.string({ required_error: message }).min(1, message)

export const supplierAddressSchema = z.object({
  id: z.string().optional().nullable(),
  addressType: z
    .object({ id: z.number(), name: z.string(), value: z.string() })
    .optional()
    .nullable(),
  line1: stringOptional(),
  line2: stringOptional(),
  city: stringOptional(),
  region: stringOptional(),
  postCode: stringOptional(),
  country: stringOptional()
})

export const supplierSchema = z.object({
  id: stringOptional(),
  name: stringRequired('Supplier name is required!'),
  contactPersonEmail: z.union([z.string({ required_error: 'Supplier email is required!' }).email('Please enter a valid email!'), z.literal('')]),
  contactPerson: stringOptional(),
  contactPersonPhoneNumber: stringOptional(),
  contactPersonMobileNumber: stringOptional(),
  supplierDescription: stringOptional(),
  isActive: z.boolean().default(true),
  addresses: z.array(supplierAddressSchema).default([]).optional().nullable()
})
